import { isFilterTypeEqual, isFilterTypeMatch, isFilterTypeRange, useProductListParamsContext } from '@graphcommerce/magento-product'
import {
  ChipOverlayOrPopperProps,
} from '@graphcommerce/next-ui'
import SelectField from '../../widgets/Form/SelectField'
import { useRouter } from 'next/router'
import { Maybe, ProductAttributeFilterInput, ProductAttributeSortInput, Scalars, SortEnum } from '@graphcommerce/graphql-mesh'



export type ProductFiltersProLimitChipProps = Omit<
  ChipOverlayOrPopperProps,
  'label' | 'selected' | 'selectedLabel' | 'onApply' | 'onReset' | 'onClose' | 'children'
>

export function createProductListLink(props: any): string {
  const { url, sort, currentPage, filters: incoming, pageSize, in_stock_only } = props
  const isSearch = url.startsWith('search')
  const filters = isSearch ? incoming : { ...incoming, category_uid: undefined }
  const uid = incoming?.category_uid?.eq || incoming?.category_uid?.in?.[0]

  // base url path generation
  let paginateSort = ``
  let query = ``

  if (currentPage && currentPage > 1) paginateSort += `/page/${currentPage}`

  // todo(paales): How should the URL look like with multiple sorts?
  // Something like: /sort/position,price/dir/asc,asc
  const [sortBy] = Object.keys(sort)
  if (sort && sortBy) query += `/sort/${sortBy}`
  if (sort && sortBy && sort[sortBy] && sort[sortBy] === 'DESC') query += `/dir/desc`
  if (pageSize) query += `/limit/${pageSize}`
  if (in_stock_only) query += `/in_stock_only/${in_stock_only}`
  // Apply filters
  if (filters)
    Object.entries(filters).forEach(([param, value]) => {
      if (!value) return
      if (isFilterTypeEqual(value) && value.in?.length)
        query += `/${param}/${value.in.sort()?.join(',')}`
      if (isFilterTypeEqual(value) && value.eq) query += `/${param}/${value.eq}`
      if (isFilterTypeMatch(value)) paginateSort += `/${param}/${value.match}`
      if (isFilterTypeRange(value)) query += `/${param}/${value.from ?? '*'}-${value.to ?? '*'}`
    })

  // it's a category with filters, use the /c/ route.
  if (query && !isSearch)
    return `/c/${url}${paginateSort}/q${uid ? `/category_uid/${uid}` : ''}${query}`

  return query ? `/${url}${paginateSort}/q${query}` : `/${url}${paginateSort}`
}

export function ProductListLimit(props: ProductFiltersProLimitChipProps) {
  const { params } = useProductListParamsContext()



  const router = useRouter()

  function toProductListParams(params: any): any {
    const { sort, ...rest } = params
    return { sort: {}, ...rest }
  }
  const push = (params: any) => {
    const queryUrl = router.query.url ?? []
    const comingFromURLWithoutFilters = !queryUrl.includes('q')

    const path = createProductListLink(params)

    if (router.asPath === path) return false

    // push the first filter, so the new route (on browser back) will be e.g. /women/fruit instead of /women
    if (comingFromURLWithoutFilters) return router.push(path, path)
    return router.replace(path, path)
  }


  return (
    <div className='w-[50px]'>
      <SelectField name='pageSize' defaultValue={params.pageSize ? Number(params.pageSize) : 16} label='' onChange={e => {
        push({ ...toProductListParams({ ...params, pageSize: Number(e.target.value) }), currentPage: 1 })
      }}>
        {[2, 4, 16, 24, 36, 48].map((item) => (
          <option value={item} key={item}>{item}</option>
        ))}
      </SelectField>
    </div>
  )
}
